module.exports = __webpack_public_path__ + "assets/img/uncheck.c3d47651.svg";